exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".bg-black-transparent[data-v-208572e0] {\n  background: rgba(0, 0, 0, 0.3);\n}\n", ""]);

// exports
